import Head from "next/head";

import { SouvenirPage } from "../../components/souvenir";

const Souvenir = () => {
  const IWidth = "600";
  const IHeight = "315";
  const image = "/static/images/souvenir/metaSouvenir.png";
  const title = "Уникальные сувениры от Donorsearch";
  const description = "Мотивационная программа для доноров крови от DonorSearch — дарим уникальные сувениры от нашего проекта! Доноры крови с 20, 75, 100 и 150 донациями могут получить значок, доноры с 3-мя донациями в течение календарного года — браслет.";

  return (
    <>
      <Head>
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="vk:image" content={image} />
        <meta property="vk:image:width" content={'537'} />
        <meta property="vk:image:height" content={'282'} />
        <meta property="twitter:image" content={image} />
        <meta property="og:image" content={image} />
        <meta property="og:image:width" content={IWidth} />
        <meta property="og:image:height" content={IHeight} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
        <link rel="image_src" href={image} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <SouvenirPage />
    </>
  );
};

export default Souvenir;